<template>
  <div class="weui-cells file-list" v-show="files.length">
    <a
      class="weui-cell weui-cell_access"
      v-for="file in files"
      :key="file.id"
      target="_blank"
      @click="download(file)"
    >
      <div class="weui-cell__hd">
        <span
          class="file-type__icon iconfont"
          :class="getIconByType(file)"
        ></span>
      </div>
      <div class="weui-cell__bd">
        <p>{{ file.name }}</p>
        <p class="list-item-muted">{{ sizeFormat(file.size) }}</p>
      </div>
      <div class="weui-cell__ft"></div>
    </a>
  </div>
</template>

<script>
import { getBaseUrl } from "@/util/env";

export default {
  props: {
    value: String,
    fileList: Array,
  },
  data() {
    return {
      files: [],
    };
  },
  mounted() {
    if (this.value) {
      this.loadData();
    }
  },
  watch: {
    value() {
      var me = this,
        value = me.value;
      if (value) {
        me.loadData();
      }
    },
    fileList() {
      var me = this,
        fileList = me.fileList;
      if (fileList) {
        me.files = fileList;
      }
    },
  },
  methods: {
    loadData() {
      var me = this,
        value = me.value;
      me.$ajax({
        url: "/api/file/info",
        params: {
          ids: value,
        },
      }).then(function (res) {
        if (res.success) {
          me.files = res.data;
        }
      });
    },
    getIconByType(file) {
      var type = file.type,
        ext = file.ext;
      if (type != "DOC") {
        return {
          IMAGE: "icon-png",
          TEXT: "icon-txt",
          COMPRESS: "icon-zip",
          VIDEO: "icon-video",
          AUDIO: "icon-audio",
          OTHER: "icon-file",
        }[type];
      } else {
        return (
          {
            doc: "icon-word",
            docx: "icon-word",
            xls: "icon-excel",
            xlsx: "icon-excel",
            ppt: "icon-ppt",
            pptx: "icon-ppt",
          }[ext] || "icon-file"
        );
      }
    },
    download(file) {
      var me = this,
        url = "",
        ua = window.navigator.userAgent.toLowerCase(),
        imgUrlList = [],
        ind = null,
        inAndriod = ua.indexOf("android") > -1;
      url = getBaseUrl() + "/api/file/download?path=" + file.fullPath;
      if (file.type === "IMAGE" && inAndriod) {
        for (let i = 0; i < me.files.length; i++) {
          if (me.files[i].type === "IMAGE") {
            let obj =
              getBaseUrl() + "/api/file/download?path=" + me.files[i].fullPath;
            imgUrlList.push(obj);
          }
        }
        imgUrlList.map((item, key) => {
          if (item == url) {
            ind = key;
          }
        });
        me.$router.push({
          name: "Gallery",
          params: {
            index: ind,
            imgUrl: url,
            imgUrlList: imgUrlList,
          },
        });
      } else if (window.uni) {
        /**
         * uniapp环境，文件下载问题
         */
        window.uni.webView.postMessage({
          data: {
            action: "downloadFile",
            params: file,
          },
        });
      } else {
        let a = document.createElement("a");
        a.href = url;
        a.click();
      }
    },
  },
};
</script>

<style scoped>
.weui-form-preview__bd > .weui-cells.file-list {
  background-color: var(--weui-BG-1);
}
</style>
